var map = {
	"./announcement.svg": 71965,
	"./apply-for.svg": 89602,
	"./arrow-down.svg": 61408,
	"./arrow-left.svg": 34383,
	"./arrow-right.svg": 91754,
	"./arrow-up.svg": 52179,
	"./back.svg": 40865,
	"./broschure.svg": 93747,
	"./calendar.svg": 83274,
	"./certificate.svg": 28333,
	"./chair.svg": 3263,
	"./clock.svg": 3082,
	"./close.svg": 15020,
	"./conferences.svg": 32957,
	"./contact.svg": 16772,
	"./customized-programs.svg": 93623,
	"./customized-special-offer.svg": 50292,
	"./down.svg": 79620,
	"./download.svg": 77640,
	"./duesseldorf.svg": 78024,
	"./early-bird.svg": 45515,
	"./ects-granting-programs.svg": 8732,
	"./exchange.svg": 73727,
	"./external.svg": 79837,
	"./facebook.svg": 70652,
	"./info.svg": 49924,
	"./less.svg": 23979,
	"./linkedin.svg": 40806,
	"./location-pin.svg": 74727,
	"./medal.svg": 77665,
	"./more.svg": 39683,
	"./network.svg": 73882,
	"./newsletter.svg": 73145,
	"./next.svg": 71107,
	"./open-programs.svg": 4858,
	"./opening.svg": 20040,
	"./participants-profile.svg": 82322,
	"./participants.svg": 67534,
	"./pause.svg": 15926,
	"./play.svg": 48150,
	"./practice-oriented.svg": 25580,
	"./prev.svg": 52847,
	"./price.svg": 54111,
	"./search.svg": 32292,
	"./sign-in.svg": 71777,
	"./speach.svg": 28846,
	"./square-meters.svg": 67212,
	"./volume-off.svg": 46550,
	"./volume-on.svg": 41344,
	"./worldwide.svg": 33729
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34027;